import React, {Component} from 'react';
import {CurrencyInput} from 'components/dashboard/buy-and-sell/CurrencyInput';
import {InputCheckbox} from "components/common/InputCheckbox";
import {MoneyField} from "buenLib/components/MoneyField";
import {Spinner} from "reactstrap";
import {Currency} from "buenLib/domain/Currency";
import {app} from "app/app";
import 'assets/sass/dashboard/buy-and-sell/Form.scss';

export class Form extends Component {
    constructor(props) {
        super(props);

        this.state = {
            plansDeclarationIsChecked: false,
            haveNotTriedToContinue: true,
            limitAvailable: '',
            limitConsumed: '',
            limitTotal: '',
            loading: true,
        }

        this.handlePlansDeclarationCheckboxChange = this.handlePlansDeclarationCheckboxChange.bind(this);
        this.handleContinue = this.handleContinue.bind(this);
        this.getOperationLimitStatus = this.getOperationLimitStatus.bind(this);
        this.isOperationCryptoToFiat = this.isOperationCryptoToFiat.bind(this);
    }

    componentDidMount() {
        if(this.isOperationCryptoToFiat()) this.getOperationLimitStatus();
    }

    handlePlansDeclarationCheckboxChange(name, newState) {
        this.setState({plansDeclarationIsChecked: newState});
    }

    handleContinue() {
        this.setState({haveNotTriedToContinue: false});
        if (this.state.plansDeclarationIsChecked) {
            this.props.handleContinue();
        }
    }

    isOperationCryptoToFiat() {
        return Currency.isFiat(this.props.operationForm.askCurrency());
    }

    getOperationLimitStatus() {
        app.apiClient().getOperationLimitStatus(response => {
            this.setState({
                limitAvailable: `${response.content().available <= 0 ? '0' : response.content().available} ${response.content().currency_code.toUpperCase()}`,
                limitConsumed: `${response.content().consumed} ${response.content().currency_code.toUpperCase()}`,
                limitTotal: `${response.content().total} ${response.content().currency_code.toUpperCase()}`,
                isNegative: parseInt(response.content().available) <= 0,
                loading: false
            });
        });
    }

    renderLimits() {
        return !this.state.loading ? <div className="limitStatusCryptoFiatOperation">
                <p>Límites de operación</p>
                <ul >
                    <li>
                        <h2>Disponible: </h2>
                        <span className={this.state.isNegative ? 'negative' : 'positive'}>{this.state.limitAvailable}</span>
                    </li>
                    <li>
                        <h2>Utilizado: </h2>
                        <span>{this.state.limitConsumed}</span>
                    </li>
                    <li>
                        <h2>Total: </h2>
                        <span>{this.state.limitTotal}</span>
                    </li>
                </ul>
            </div> : <Spinner className="spinner-color"/>
    }

    render() {
        let operationForm = this.props.operationForm;

        if (this._hasPricesBalanceAndLimits()) {
            return (
                <div>
                    <div className="buy-and-sell-inputs">
                        <div>
                            <div className="label">
                                {operationForm.verboseBidCurrency()} que vas
                                a {operationForm.isBuy() ? " comprar" : " vender"}
                            </div>
                            <CurrencyInput currency={operationForm.bidCurrency()}
                                           name={operationForm.bidCurrency()}
                                           field={operationForm.bidField()}
                                           handleChange={this.props.handleInputChange}
                                           maxBalance={operationForm.balanceData()[operationForm.bidCurrency()]}/>
                        </div>
                        <div className="buy-and-sell-center">=</div>
                        <div>
                            <div className="label">
                                {operationForm.verboseAskCurrency()} que vas
                                a {operationForm.isSell() ? " recibir" : " pagar"}
                            </div>
                            <CurrencyInput currency={operationForm.askCurrency()}
                                           name={operationForm.askCurrency()}
                                           field={operationForm.askField()}
                                           handleChange={this.props.handleInputChange}
                                           maxBalance={operationForm.balanceData()[operationForm.askCurrency()]}/>
                        </div>
                    </div>
                    <div className="summary-data">
                        <p>Tu cotización <b className="price"><MoneyField value={operationForm.rate().toString()}
                                                                          currency={this.priceCurrency()}
                                                                          suffix={` ${operationForm.prettyAskCurrency()}/${operationForm.prettyBidCurrency()}`}/></b>
                        </p>
                        {this.isOperationCryptoToFiat() && this.renderLimits()}
                        {this.renderFeeCharges(operationForm)}
                        {this.renderTaxCharges(operationForm, "Impuesto PAIS")}
                    </div>
                    <div className="plans-declaration">
                        <InputCheckbox
                            handleChange={this.handlePlansDeclarationCheckboxChange}
                            label="Al continuar declaro bajo juramento que mis fondos no provienen de planes y programas sociales en Argentina."
                        />&nbsp;
                        {this.state.haveNotTriedToContinue || this.state.plansDeclarationIsChecked ? "" :
                            <p className="error-message">Es necesario que aceptes la declaración jurada para
                                continuar.</p>}
                    </div>
                    <div className="text-center mt-4">
                        <button className={`cta-button`}
                                onClick={this.handleContinue}>
                            CONTINUAR
                        </button>
                    </div>
                    <div className="text-center mt-4">
                        <p className="text-terms">
                            * Tengo pleno conocimiento de estar operando en la compra y venta de criptomonedas y todas
                            sus implicancias impositivas, financieras y riesgos.
                        </p>
                    </div>
                </div>
            );
        } else {
            return (
                <div className="text-center">
                    <Spinner className="spinner-color"/>
                </div>
            );
        }
    }

    priceCurrency() {
        let operationForm = this.props.operationForm;
        let bidCurrency = operationForm.bidCurrency();
        let askCurrency = operationForm.askCurrency();
        return Currency.priceCurrency(bidCurrency, askCurrency);
    }

    _hasPricesBalanceAndLimits() {
        return this.props.data.purchasePrice !== undefined && this.props.data.sellingPrice !== undefined && !this.props.balanceAndLimitsLoading
    }

    renderFee(operationForm) {
        return (
            <b>
                <MoneyField
                    defaultValue={0.0}
                    currency={operationForm.feeCurrency()}
                    value={operationForm.feeAmount()}
                    prefix={operationForm.prettyFeeCurrency() + " "}/> ({operationForm.verboseFeeCurrency()})
            </b>
        );
    }

    renderTaxCharges(operationForm, taxLabel) {
        if (operationForm.hasTax()) {
            return (
                <p>
                    {taxLabel} ({operationForm.percentageForTax()}%):&nbsp;
                    <b>
                        <MoneyField
                            defaultValue={0.0}
                            currency={operationForm.askCurrency()}
                            value={operationForm.taxAmount()}
                            prefix={operationForm.prettyFeeCurrency() + " "}/> ({operationForm.verboseFeeCurrency()})
                    </b>
                </p>
            );
        }
    }

    renderFeeCharges(operationForm) {
        if (operationForm.hasFee()) {
            return <p>Comisión de {operationForm.feePercent()}% = {this.renderFee(operationForm)}</p>
        }
    }
}
